import {useEffect} from "react";
import {useLeafletMap} from "./leaflet";
import {useMapContext} from "./MapProvider";
import {HEADER_HEIGHT} from "base/ui/baseApp/config/measurements";

const mapDefaultStyle = {
    width: "100%",
    height: "100%",
    minHeight: `calc(100vh - ${HEADER_HEIGHT * 2}px)`,
    zIndex: 0,
};

const MapView = ({style: mapCustomStyle = {}}) => {
    const {createMap, isMapLoaded, removeMap, zoomToBbox, zoomToPoint} =
        useLeafletMap();

    const {mapDOMRef, boundingBox, searchedLocation} = useMapContext();

    useEffect(() => {
        createMap();

        return () => {
            if (isMapLoaded()) {
                removeMap();
            }
        };
    }, []);

    useEffect(() => {
        if (boundingBox) zoomToBbox(boundingBox);
    }, [boundingBox]);

    useEffect(() => {
        if (searchedLocation) {
            zoomToPoint(searchedLocation);
        }
    }, [searchedLocation]);

    return (
        <div id="map" style={{...mapDefaultStyle, ...mapCustomStyle}} ref={mapDOMRef} />
    );
};
export default MapView;
